import React from 'react'
import Layout from '../components/layout'
import ContactFormContainer from '../components/pages/contact/ContactFormContainer'
import Billboard from '../components/Billboard'
import Seo from '../components/seo'
import contactData from "../content-data/contact/contacts.json";
import CorporateMailingAddress from "../components/CorporateMailingAddress/CorporateMailingAddress";


const ContactPage = ({ data }) => {

  return (
    <Layout showContact={false}>
      <Seo
        title="Contact Us: Email & Phone for Sales and Support"
        description="Fantastic Support made us the world leader in AWS Cloud Services. Contact Sales or Support any time night or day, we are here for you. Find out more today."
      />

      <Billboard className="Billboard--contact" color="white">
        <div className="Billboard__top">
          <h1 className="Billboard__title">{contactData.headLine}</h1>
          <div
            className="Billboard__lead"
            dangerouslySetInnerHTML={{
              __html: contactData.description,
            }}
          />
          <div className="Billboard__cta" />
        </div>

        <div className="Billboard__right">
          <div className="contactForm">
            <ContactFormContainer />
          </div>
        </div>
      </Billboard>

      <section className="section sectionExperience">
        <div className="container"></div>
      </section>

      <section className="sectionCities">
        <CorporateMailingAddress />
      </section>
    </Layout>
  )
}

export default ContactPage
